let language = {
    // 
    STANDARD_ORDER_WAITING_PAYMENT_TIME_TIP: "（您可以在创建订单后{{paymentWaitingTime}}分钟内支付此订单，否则将在{{paymentWaitingTime}}分钟后取消。）",

    // 
    STANDARD_ORDER_PAYMENT_TIME_COUNT_TIP1: "您可以在",
    STANDARD_ORDER_PAYMENT_TIME_COUNT_TIP2: "秒内支付此订单。",
    STANDARD_ORDER_PAYMENT_TIME_COUNT_TIP3: "分钟内支付此订单。",

    // 
    standard_order_payment_fail_tip_title: "支付失败",
    standard_order_payment_fail_tip_content: "此订单在30分钟内未支付或已取消。",

    // 
    standard_order_cancel_order_tip_title: "订单取消成功！",
    standard_order_cancel_order_tip_content: "跳转到订单列表。",

    STANDARD_ORDER_WAITING_PAYMENT_FAILED_DES1: "订单支付失败，您可以前往",
    STANDARD_ORDER_WAITING_PAYMENT_FAILED_DES2: "查看原因。"
};

export { language }
